/**
 *Created by jmmartinez on 12/03/2020
 *  v.1.0 15/09/2020
 *  v.2.0 03/12/2020 Pasado a Framework 2.0
 *  **/

import React from 'react'
import {Dialog, Tooltip, Button} from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import {Classes} from "@blueprintjs/core/lib/esm/index";


class DialogoSiNo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            mostrar: false,
        }
        this.ref = React.createRef();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};
        if (nextProps.mostrar !== prevState.mostrar) {
            newState.mostrar = nextProps.mostrar;
        }
        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    componentDidUpdate() {
        if (this.ref && this.ref.current)
            this.ref.current.focus();
    }


    onClose= () => {
        console.log("onClose");
        const {onClose} = this.props;
        this.setState({mostrar: false});
        onClose && onClose();
    }

    onQuestion= (respuesta) => {
        const {onQuestion} = this.props;
        this.setState({mostrar: false});
        onQuestion && onQuestion(respuesta);
    }

    render() {
        const { mostrar} = this.state;
        const {titulo, mensaje, onQuestion} = this.props;
        let tituloTransformado= titulo ? titulo : ""; //Para evitar el warning con icon
        return (
            <Dialog title={tituloTransformado}
                    onClose={this.onClose}
                    isOpen={mostrar && Boolean(mostrar) === true}
                    usePortal= {true}
                    style={{ width: "60%", backgroundColor: 'white'}}
            >
                <div className={Classes.DIALOG_BODY}>
                    <div style={{textAlign: 'center'}}>
                        {mensaje}
                    </div>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Tooltip content="Aceptar">
                            <Button onClick={() => this.onQuestion(true)}>Aceptar</Button>
                        </Tooltip>
                        <Tooltip content="Cancelar">
                            <Button onClick={() => this.onQuestion(false)}>Cancelar</Button>
                        </Tooltip>
                    </div>
                </div>
            </Dialog>
        );
    }
}


DialogoSiNo.propTypes = {
    mostrar: PropTypes.bool,
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
    onClose: PropTypes.func,
    onQuestion: PropTypes.func,
}

export default DialogoSiNo

